import { Route } from 'vue-router'
import { URLS } from '@/router/routes/urlRoutes'
import { useAuthStore } from '@/stores/auth/useAuthStore'
import { pinia } from '@/main'
import { checkNoRequiresAuthURL } from '../helpers/routes'

export const loginNoRequiresAuth = (to: Route, from: Route, next: any): void => {
  const noRequiresAuth = checkNoRequiresAuthURL(to.name ?? '')

  if (to.fullPath === from.fullPath) return

  const authStore = useAuthStore(pinia)
  if (!authStore.isUserLogged && !noRequiresAuth) {
    authStore.setNextUrl({ ...to, name: to.name ?? '' })
    return next({ name: URLS.LOGIN })
  }

  return next()
}
